import moment from 'moment';
import MomentTz from 'moment-timezone';
import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import {
  Autocomplete, Button, Card, Cell,
  DataTable, DatePicker, DialogContainer, Grid,

  TableBody,

  TableColumn,
  TablePagination,
  TableHeader, TableRow, TimePicker
} from 'react-md';
import MultiSelectReact from 'react-multi-select-ext';
import { NotificationManager } from 'react-notifications';
import ApiRequestService from '../component/ApiRequestService';
import LoadingSpinner from '../component/LoadingSpinner';
import EnrolledStudentsDropDown from '../component/EnrolledStudentsDropDown';
import "../css/EditWindow.css"


const getSectionIDs = function(SectionList){
  let sectionIDArray = [];

  sectionIDArray = SectionList.map((section) => {
    return section.id;
  });

  return sectionIDArray;
}

const getSubSectionIDs = (sectionArr) => {
  let tempSubsectionIDs = [];
  if(sectionArr.length > 0){
    sectionArr.map(sectionData => {
      if(sectionData?.subsectionList && sectionData.subsectionList.length > 0){
        sectionData.subsectionList.map((subsectionData)=>{
          if(subsectionData?.value){
            tempSubsectionIDs.push(subsectionData.id)
          }
        })
      }
    })
  }

  return tempSubsectionIDs;
}

const isValidDate = function(d) {
    return d instanceof Date && !isNaN(d);
  }

const disabledButton = {
  marginLeft:"18px",
  backgroundColor: 'grey',
  color: 'white'
};

export default class EditWindow extends Component {
   
    constructor(props) {
      super(props);
      this.state = {
        studentStartTime:'',
        studentEndTime:'',
        studentStartDate:'',
        studentEndDate:'',
        studentID:'',
        studentQuizDetailsArr:[],
        updateVisible:false,
        enableSubmit:true,
        loadingSave:false,
        updateSectionVisible:false,
        sectionQuizDetailsArr:[],
        sectionList:this.props.sectionList,        
        sectionStartDate:'',
        sectionEndDate:'',
        studentIDs:[],
        studentIDObj:[],
        releaseStudentIDs:[],
        updateStudentVisible: false,
        locksHistory:[],
        slicedLocksData:[],
        studentExtendIndex:""
      };
      this.studentNameOnChange = this.studentNameOnChange.bind(this);
      this.handleStudentStartDate = this.handleStudentStartDate.bind(this);
      this.handleStudentEndDate = this.handleStudentEndDate.bind(this);
      
      this.saveStudentQuizTime = this.saveStudentQuizTime.bind(this);
      this.getStudentQuizTime = this.getStudentQuizTime.bind(this);
      this.updateStudentDetails = this.updateStudentDetails.bind(this);
      this.updateVisibleHide = this.updateVisibleHide.bind(this);
      this.updateVisibleShow = this.updateVisibleShow.bind(this);

      this.updateSectionVisibleHide = this.updateSectionVisibleHide.bind(this);
      this.updateSectionVisibleShow = this.updateSectionVisibleShow.bind(this);
      this.handleSectionStartDate = this.handleSectionStartDate.bind(this);
      this.handleSectionEndDate = this.handleSectionEndDate.bind(this);
      this.saveSectionQuizTime = this.saveSectionQuizTime.bind(this);
      
      
    }

    componentWillMount(){
      
        this.getSectionQuizTime();
        this.getStudentQuizTime();
        this.getLocksHistory()
        let sectionList =JSON.parse(JSON.stringify(this.state.sectionList.slice()));
        if(sectionList != null ){
          for(var i =0; i < sectionList.length; i++){
            sectionList[i].value = false;
          }
        }

        //Get Enrolled Student's list
        this.getEnrolledStudentsList(sectionList);

        this.setState({sectionList});

    }
    
  getStudentQuizTime(){
    console.debug("getStudentQuizTime = ");
    let quizID = parseInt(this.props.quizID, 10);
    if(quizID != null){
      const payload = {            
        quiz_id:quizID,      
      };

      ApiRequestService({
        method: 'post',
        url: '/getStudentQuizTime',
        data:payload
      }).then(res => {
        console.debug("Response = ",res);
        this.studentDataResponse(res);
        if(
          res.data.data.student_quiz_time === undefined || 
          res.data.data.student_quiz_time === null ){
  
          this.setState({
            studentQuizDetailsArr: [],
          });

      }

      this.setState({ loading: false });
          
        
      });
    }
  }
  getLocksHistory(){

    let quizID = parseInt(this.props.quizID, 10);
    if(quizID != null){
      const payload = {            
        quiz_id:quizID,      
      };

      ApiRequestService({
        method: 'post',
        url: '/locksHistoryByQuiz',
        data:payload
      }).then(res => {
        let LocksData = res.data.data.locksDetails
        
        const lockHistory = LocksData?.map((data, index) => {
          return {
            ...data,
            sno: index + 1
          }
        })

        if(lockHistory && lockHistory?.length > 0) {

          this.setState({
            locksHistory:lockHistory,
            slicedLocksData:lockHistory.slice(0,8)
          })
            
        }
        
        
      });
    }
  }

  getSectionQuizTime(){
    console.debug("getSectionQuizTime = ");
    let quizID = parseInt(this.props.quizID, 10);
    if(quizID != null){
      const payload = {            
        quiz_id:quizID,      
      };

      ApiRequestService({
        method: 'post',
        url: '/getSectionQuizTime',
        data:payload
      }).then(res => {
        console.debug("section Response = ",res);
        this.sectionDataResponse(res);
          
        
      });
    }
  }

  studentQuizTimeList() {
    let StduentList  = this.state.studentIDs
    let alreadyExtendStudent = this.state.studentQuizDetailsArr
    
    //remaining Students
    let remainingStudent = StduentList.filter(student => {
      return !alreadyExtendStudent.map(stu => stu.student_id).includes(student);
    })

    return remainingStudent
  }
  studentDataResponse(res){

    if(res !== undefined && res != null &&
        res.data !== undefined && res.data != null &&   
        res.data.data !== undefined && res.data.data != null &&
        res.data.data.student_quiz_time !== undefined && 
        res.data.data.student_quiz_time != null ){

        this.setState({
          studentQuizDetailsArr: res.data.data.student_quiz_time,
        });

        console.log("studentQuizDetailsArr",this.state.studentQuizDetailsArr);
    }
    if(res !== undefined && res != null &&
        res.data !== undefined && res.data !== null &&   
        res.data.data !== undefined && res.data.data !== null &&
        res.data.data.message !== undefined && 
        res.data.data.message !== null && res.data.data.message !== ""  ){
            NotificationManager.error(res.data.data.message, 'ERROR', 3000);


     }
    this.setState({studentStartDate:'',
        studentEndDate:'',
        studentID:''
    });
  }

  sectionDataResponse(res){

    if(res !== undefined && res != null &&
        res.data !== undefined && res.data != null &&   
        res.data.data !== undefined && res.data.data != null &&
        res.data.data.section_quiz_time !== undefined && 
        res.data.data.section_quiz_time != null ){

        this.setState({
          sectionQuizDetailsArr: res.data.data.section_quiz_time,
        });

        console.log("sectionQuizDetailsArr",this.state.sectionQuizDetailsArr);
    }
    if(res !== undefined && res != null &&
        res.data !== undefined && res.data != null &&   
        res.data.data !== undefined && res.data.data != null &&
        res.data.data.message !== undefined && 
        res.data.data.message != null && res.data.data.message !== ""  ){
            NotificationManager.error(res.data.data.message, 'ERROR', 3000);


     }
  }

    studentNameOnChange(e) {
        console.debug('studentNameOnChange', e);
        //console.debug("assignmentNameOnChange",e.target.value);
        var tempName = e;
        this.setState({
            studentID: tempName
        });
        }

        
  saveStudentQuizTime(){

    
    let StudentList = this.state.studentIDs
    let currentID = this.state.studentID
    let alreadyExtendStudent = this.state.studentQuizDetailsArr

    if (!StudentList.includes(this.state.studentID)) {
      NotificationManager.error('Please enter vaild student name', 'ERROR', 3000);
      return;
    }

    if (alreadyExtendStudent.some(student => student.student_id === currentID)) {
      NotificationManager.error('The due date has already been extended for the student. Please edit in the Students Window List.', 'ERROR', 3000);
      return;
    }
    
    if(this.state.studentID === null || this.state.studentID === ""){
        NotificationManager.error('Please enter vaild student name', 'ERROR', 3000);
        return;
    }
    
    if(this.state.studentStartDate === null || this.state.studentStartDate ===""){
        NotificationManager.error('Please enter vaild Start Date and time', 'ERROR', 3000);
        return;
    }
    if(this.state.studentEndDate === null || this.state.studentEndDate === ""){
        NotificationManager.error('Please enter vaild end Date and time', 'ERROR', 3000);
        return;
    }
    
    this.setState({enableSubmit: false,
        loadingSave: true});

    console.log("studentStartDate",this.state.studentStartDate);
    console.log("studentEndDate",this.state.studentEndDate);
    console.log("studentID",this.state.studentID);

    
    let quizID = parseInt(this.props.quizID, 10);
    console.log("studentID",quizID );
    if(quizID === null &&  quizID === 0 ){
      NotificationManager.error('Assignment id is not vaild', 'ERROR', 3000);
      return;
    }
    
    
    var tempStartDate = this.state.studentStartDate.format('YYYY/MM/DD HH:mm');
    var tempEndDate = this.state.studentEndDate.format('YYYY/MM/DD HH:mm');
    const payload = {      
      student_id:this.state.studentID,
      quiz_id:quizID,
      student_start_time:tempStartDate,
      student_end_time:tempEndDate
    };
    console.log("payload",payload);

    ApiRequestService({
      method: 'post',
      url: '/saveStudentQuizTime',
      data:payload
    }).then(res => {
      console.debug("Response = ",res);
      this.studentDataResponse(res);
      this.setState({enableSubmit: true,loadingSave: false});
      NotificationManager.success('Saved successfully', 'Success', 3000);
      this.updateVisibleHide();
      this.getStudentQuizTime()
      
      
    });
  }


  saveSectionQuizTime(){
    
    console.log("saveSectionQuizTime");
    if(this.state.sectionStartDate === null || this.state.sectionStartDate ===""){
        NotificationManager.error('Please enter vaild Start Date and time', 'ERROR', 3000);
        return;
    }
    if(this.state.sectionEndDate === null || this.state.sectionEndDate === ""){
        NotificationManager.error('Please enter vaild end Date and time', 'ERROR', 3000);
        return;
    }
    
    this.setState({enableSubmit: false,
        loadingSave: true});

    console.log("sectionStartDate",this.state.sectionStartDate);
    console.log("sectionEndDate",this.state.sectionEndDate);
    let quizID = parseInt(this.props.quizID, 10);
    console.log("quizID",quizID );
    if(quizID === null &&  quizID === 0 ){
      NotificationManager.error('Assignment id is not vaild', 'ERROR', 3000);
      return;
    }
    
    var courseId = parseInt(this.props.courseID,10);
    var sectionId = parseInt(this.props.sectionID,10);
    var tempStartDate = this.state.sectionStartDate.format('YYYY/MM/DD HH:mm');
    var tempEndDate = this.state.sectionEndDate.format('YYYY/MM/DD HH:mm');
    var tempSection = this.state.sectionList;
    
    var tempInsertSection = [];
    console.debug('this.state.sections', tempSection);
    for (var i = 0; i < tempSection.length; i++) {
      if (tempSection[i].value === true) {
        var tempInsert = {};
        tempInsert['id'] = tempSection[i].id;
        tempInsert['label'] = tempSection[i].label;
        tempInsert['value'] = tempSection[i].value;
        tempInsert['course_id'] = courseId;
        tempInsert['semester_id'] = sectionId;

        tempInsertSection.push(tempInsert);
      }
    }

    if(tempInsertSection.length <= 0 ){
      NotificationManager.error('Section list is not Vaild Please select atleast a section  ', 'ERROR', 3000);
      return;
    }
    const payload = {            
      course_id:courseId,
      section_id:sectionId,
      quiz_id:quizID,
      section_start_time:tempStartDate,
      section_end_time:tempEndDate,
      sections_list:tempInsertSection
    };
    console.log("payload",payload);

    ApiRequestService({
      method: 'post',
      url: '/updateSectionQuizTime',
      data:payload
    }).then(res => {
      console.debug("Response = ",res);
      this.sectionDataResponse(res);
      this.setState({loadingSave: false});
      NotificationManager.success('Saved successfully', 'Success', 3000);
      this.updateSectionVisibleHide();

    });

  }

  
  handleStudentStartDate(timeString, sDate, event) {
    console.log("handleStudentStartDate",sDate);
      if (sDate !== null) {
        this.setState({
          studentStartDate: moment(sDate)
        });
      }
    }
  
  handleStudentEndDate(timeString, sDate, event) {
    console.log("handleStudentEndDate",sDate);
    if (sDate !== null) {
      this.setState({
        studentEndDate: moment(sDate)
      });
    }
  }

  onStudentChange = (argStudentIDs) => {
    let releaseStudentData = []
    argStudentIDs.forEach(row => {
        if(row.id !== 'enableAll' && row.id !== 'enableNone' && row.value){
          releaseStudentData.push(row.label);
        }  
    })

    console.log("releaseStudentIDs=", releaseStudentData)
    this.setState({
      releaseStudentIDs: [...releaseStudentData],
      studentIDObj: argStudentIDs
    });
  };
  

  editStudentDetails(id) {

    console.debug("editStudentDetails");

   var tempStudentQuizDetailsArr = this.state.studentQuizDetailsArr[id];
   console.debug("tempStudentQuizDetailsArr",tempStudentQuizDetailsArr);
    //University Time Adjusted
    let studentStartTimeUniv = moment(tempStudentQuizDetailsArr.student_start_time).toDate()
    let studentEndTimeUniv = moment(tempStudentQuizDetailsArr.student_end_time).toDate()
    studentStartTimeUniv.setMinutes(studentStartTimeUniv.getMinutes() + studentStartTimeUniv.getTimezoneOffset())
    studentEndTimeUniv.setMinutes(studentEndTimeUniv.getMinutes() + studentEndTimeUniv.getTimezoneOffset())
    this.setState({
      studentID: tempStudentQuizDetailsArr.student_id,
      studentStartDate: moment(tempStudentQuizDetailsArr.student_start_time),
      studentEndDate: moment(tempStudentQuizDetailsArr.student_end_time),
      studentEditIsEnable:true,
      studentStartDate:moment(studentStartTimeUniv),
      studentEndDate: moment(studentEndTimeUniv),
      studentEditIsEnable:true,
      studentExtendIndex:id
    });

    this.setState({
        updateVisible: true,
      });

  }
  

  

  updateStudentDetails() {

    

    console.log("updateStudentDetails");

    if(this.state.studentID === null || this.state.studentID === ""){
        alert('Please enter vaild student name');
        return;
    }
    
    if(this.state.studentStartDate === null || this.state.studentStartDate === ""){
        NotificationManager.error('Please enter vaild Start Date and time', 'ERROR', 3000);
        return;
    }
    if(this.state.studentEndDate === null || this.state.studentEndDate === ""){
        NotificationManager.error('Please enter vaild end Date and time', 'ERROR', 3000);
        return;
    }
    this.setState({
        enableSubmit: false,
        loadingSave: true});
    

    console.log("studentStartDate",this.state.studentStartDate);
    console.log("studentEndDate",this.state.studentEndDate);
    console.log("studentID",this.state.studentID);

    
    let quizID = parseInt(this.props.quizID, 10);
    console.log("studentID",quizID );
    if(quizID === null &&  quizID === 0 ){
      NotificationManager.error('Assignment id is not vaild', 'ERROR', 3000);
      return;
    }
    
    let tempDetailStudent = this.state.studentQuizDetailsArr
    let quizDetail = tempDetailStudent[this.state?.studentExtendIndex]
    
    
    var tempStartDate = this.state.studentStartDate.format('YYYY/MM/DD HH:mm');
    var tempEndDate = this.state.studentEndDate.format('YYYY/MM/DD HH:mm');
    const payload = {      
      student_id:this.state.studentID,
      quiz_id:quizID,
      student_start_time:tempStartDate,
      student_end_time:tempEndDate,
      student_quiz_time_id:quizDetail?.student_quiz_time_id
    };
    console.log("payload",payload);

    ApiRequestService({
      method: 'post',
      url: '/updateStudentQuizTime',
      data:payload
    }).then(res => {
      console.debug("Response = ",res);
      this.studentDataResponse(res);
      this.getStudentQuizTime()
      this.setState({enableSubmit: true,
        loadingSave: false});
      NotificationManager.success('Update successfully', 'Success', 3000);
      this.updateVisibleHide();

      
    });

  }



  deleteStudentDetails(quizDetail) {
    console.debug("deleteStudentDetails");
    this.setState({ loading: true });
   
    const startDateTime = new Date(quizDetail.student_start_time);
    const endDateTime = new Date(quizDetail.student_end_time);

    // Format to MySQL datetime format
    const formattedStartDatetime = startDateTime.toISOString().slice(0, 19).replace("T", " ");
    const formattedEndDatetime = endDateTime.toISOString().slice(0, 19).replace("T", " ");
    let quizID = parseInt(this.props.quizID, 10);


    const payload = {
      student_id:quizDetail.student_id,
      quiz_id:quizID,  
      student_start_time:formattedStartDatetime,
      student_end_time:formattedEndDatetime,
      student_quiz_time_id:quizDetail?.student_quiz_time_id
    };
    
    ApiRequestService({
      method: 'post',
      url: '/deleteStudentQuizTime',
      data: payload
    })
      .then(res => {
        this.setState({
          loading:false
        });
        console.debug(res);
        this.getStudentQuizTime()
        
      })
      .catch(error => {
        console.error('Error When Deleting ', error);
        if (error.status !== undefined && error.status === 403) {
          //User Doesnt Have Access
          NotificationManager.error(
            'Unauthorized',
            'You are not authorized to delete subcategory',
            5000
          );
        }
       
      });
  } 
  delete = quizDetail => {
    confirmAlert({
      title: 'Are you sure want to delete this Student details?',
      message: 'Press Confirm to submit',

      cancelLabel: 'Confirm',
      confirmLabel: 'Cancel',
      onCancel: () => this.deleteStudentDetails(quizDetail),
  
    });
  };

  updateVisibleHide() {

    this.setState({
        updateVisible: false,
    });
    
  }
  updateVisibleShow() {
   
     //this.getStudentQuizTime();
      this.setState({
        updateVisible: true,
        studentEditIsEnable:false,
        studentID:"",
        studentStartDate:"",
        studentEndDate:"",
        studentExtendIndex:""
      });
    
  }

  releaseLocks = () => {
   
   let quizID = parseInt(this.props.quizID, 10);
   const payload = {      
                    student_id:this.state.releaseStudentIDs,
                    quiz_id:quizID
                    };

    ApiRequestService({
      method: 'post',
      url: '/releaseLocks',
      data:payload
    }).then(res => {
      //fetch history
      this.getLocksHistory()
      if(res?.data?.data) return NotificationManager.success('Lock Released successfully', 'Success', 3000);
      return NotificationManager.error('Lock Released failed!', 'ERROR', 3000);
    });
   
  }


  handlePagination = (start, rowsPerPage) => {
    this.setState({
      slicedLocksData: this.state.locksHistory.slice(start, start + rowsPerPage)
    });
  };
  updateSectionVisibleHide() {
    
    var tempSectionList = this.state.sectionList;

    for (var i = 0; i < tempSectionList.length; i++){
      tempSectionList[i].value = false;
    }

    this.setState({
      updateSectionVisible: false,
      sectionList:tempSectionList,
      sectionStartDate:'',
      sectionEndDate:'',
    });
    
  }
  updateSectionVisibleShow() {
   
      //this.getStudentQuizTime();
      this.setState({
        updateSectionVisible: true,
      });
    

  }
  optionClicked(optionsList) {
    
    console.debug('selected optionClicked', optionsList);

    this.setState({
      sectionList: optionsList
    
    });
  }
  
  selectedBadgeClicked(optionsList) {
    console.debug('selectedBadgeClicked', optionsList);
    this.setState({
      sectionList: optionsList    
    });
  }

  handleSectionStartDate(timeString, sDate, event) {
    console.log("handleSectionStartDate",sDate);
      if (sDate !== null) {
        this.setState({
          sectionStartDate: moment(sDate)
        });
      }
    }
  
  handleSectionEndDate(timeString, sDate, event) {
    console.log("handleSectionEndDate",sDate);
    if (sDate !== null) {
      this.setState({
        sectionEndDate: moment(sDate)
      });
    }
  }
  editSectionDetails(index){
    console.log("editStudentDetails = ",this.state.sectionQuizDetailsArr[index]);
    var tempSectionQuizDetailsArr = this.state.sectionQuizDetailsArr[index];
    console.debug("tempSectionQuizDetailsArr",tempSectionQuizDetailsArr);
    var tempSectionList = this.state.sectionList;
    console.debug("tempSectionList = ",tempSectionList);

    for(var i = 0; i < tempSectionList.length; i++){
      console.debug("tempSectionList",tempSectionList[i]);
      if(tempSectionQuizDetailsArr.section_id === tempSectionList[i].id){
        tempSectionList[i].value = true;
      }
    }

    console.log("tempSectionQuizDetailsArr.section_end_time",tempSectionQuizDetailsArr.section_end_time);
    console.log("tempSectionQuizDetailsArr.section_start_time",tempSectionQuizDetailsArr.section_start_time);
    this.setState({
      sectionList:tempSectionList,
      sectionEndDate: moment(tempSectionQuizDetailsArr.section_end_time),
      sectionStartDate: moment(tempSectionQuizDetailsArr.section_start_time),      
      updateSectionVisible: true,
       
    });
    console.debug("sectionEndDate = ",this.state.sectionEndDate);
    console.debug("sectionStartDate = ",this.state.sectionStartDate);
    
       
  }

//User ID Search Feature Start
  getEnrolledStudentsList = async(sectionList) =>{
    const sectionIDs = getSectionIDs(sectionList);
    const courseID = parseInt(this.props.courseID,10);
    const subsectionIDs = getSubSectionIDs(this.props.selectedSectionAndSubsection)
    const payload = {
      courseID:courseID,
      sectionIDs:sectionIDs,
      isEnableSubsection: this.props.isEnableSubsection,
      subsectionIDs: subsectionIDs
    };

    try{
      let res =  await ApiRequestService({
                                                method: 'post',
                                                url: '/getEnrolledStudents',
                                                data: payload
                                              });
      if(res.data !== undefined
        && res.data !== null 
        && res.data.status !== undefined
        && res.data.status !== null)
        {
            if(res.data.status !== 0)
            {
                console.error(res.data.message);
                NotificationManager.error(res.data.message,"Error",5000);
            }else  {
                this.setState({studentIDs:res.data.data, studentIDObj: res.data.data.map((d)=> {return {label:d, id:d, value:false, index:d}})});
            }
            
        }
    }catch(err){
      console.error(err);
      NotificationManager.error(err,"Error Getting Student IDs",5000);
    }
  }
  
    
  handleUserIDSearch = (value) => {
      this.setState({studentID:value})
  };

  handleAutocomplete = (value, index, matches) => {
    this.setState({studentID:value});
  };
//User ID Search Feature End
    render() {

        let studentStartDateLocal =  moment(this.state.studentStartDate).toDate();
        let studentEndDateLocal =  moment(this.state.studentEndDate).toDate();
        //let AddIconstyle = {float:"right",paddingRight:"10px"};

        console.debug("sectionStartDateLocal = ",this.state.sectionStartDate);
        console.debug("sectionEndDateLocal = ",this.state.sectionEndDateLocal);

        let sectionStartDateLocal =  moment(this.state.sectionStartDate).toDate();
        let sectionEndDateLocal =  moment(this.state.sectionEndDate).toDate();

        console.debug("sectionStartDateLocal = ",sectionStartDateLocal);
        console.debug("sectionEndDateLocal = ",sectionEndDateLocal);
        
        
        const selectedOptionsStyles = {
          color: '#FFFFFF',
          backgroundColor: '#bb0000'
        };
        const optionsListStyles = {
          backgroundColor: '#bb0000',
          color: '#FFFFFF'
        };

       
        return(                
            <div>
               <Card className="cards__example md-cell md-cell--6 md-cell--8-tablet"  style={{float:"left"}}>
          

          <div>
             <DialogContainer
               id="navigation-drawer-demo"
               aria-label="Navigation Drawer Demo"
               visible={this.state.updateSectionVisible}
               fullPage
               focusOnMount={false}           
               onHide={this.updateSectionVisibleHide}
               
             >
             <div>
               {' '}

               <Button  icon onClick={this.updateSectionVisibleHide}>
                 close
               </Button>
             </div>

           
             <div style={{width:"700px",marginLeft: "25%"}}>
             <h3>Add Section Window</h3>
           <Grid style={{width:'100%'}}>
               <Cell size={12} phoneSize={4} tabletSize={8}>
               
               Section List
             <br />
             <MultiSelectReact
               options={this.state.sectionList}
               optionClickedoptionClicked={this.optionClicked.bind(this)}
               selectedBadgeClicked={this.selectedBadgeClicked.bind(this)}
               selectedOptionsStyles={selectedOptionsStyles}
               optionsListStyles={optionsListStyles}
               
             />
               </Cell><br/>
               <Cell size={6} phoneSize={4} tabletSize={8}>
               <DatePicker
                       id="sstartDate"
                       label="Start Date"
                       displayMode="portrait"
                       value={isValidDate(sectionStartDateLocal)?sectionStartDateLocal:""}
                       onChange={this.handleSectionStartDate}


               />
               </Cell>
               <Cell size={6} phoneSize={4} tabletSize={8}>
               <TimePicker
                       id="sstartTime"
                       label="Start Time"
                       displayMode="portrait"
                       value={isValidDate(sectionStartDateLocal)?sectionStartDateLocal:""}
                       onChange={this.handleSectionStartDate}

               />  
               </Cell>
               <Cell size={6} phoneSize={4} tabletSize={8}>
               
               <DatePicker
                       id="endDate"
                       label="End Date"
                       displayMode="portrait"
                       value={isValidDate(sectionEndDateLocal)?sectionEndDateLocal:""}
                       onChange={this.handleSectionEndDate}
               />
               </Cell>
               <Cell size={6} phoneSize={4} tabletSize={8}>
                   <TimePicker
                       id="endTime"
                       label="End Time"
                       displayMode="portrait"
                       value={isValidDate(sectionEndDateLocal)?sectionEndDateLocal:""}
                       onChange={this.handleSectionEndDate}

                   />
               </Cell>
               <Cell size={4} phoneSize={4} tabletSize={8}>
               {this.state.loadingSave === true ? 
                   <LoadingSpinner /> : ( 
                   <div><Button
                   raised
                   primary
                   style={{marginRight:'10px'}}
                   className="buttonColour"
                   onClick={this.saveSectionQuizTime}>Submit</Button> 
                 
                   &nbsp;&nbsp;&nbsp;
                   <Button flat
                       secondary
                       swapTheming
                       onClick={this.updateSectionVisibleHide}> close</Button>
                       </div>
                   )}
               </Cell>
               </Grid>
               </div>

             </DialogContainer>

           </div>  

           <div>
               <h2 style={{paddingTop:"5px",paddingLeft:"20px"}}>Sections Window List </h2>
               <Button className="archive-button" primary raised
                  style={{
                    marginLeft:"18px",
                    //background: "transparent",
                    border: "none"}}
                  onClick={this.updateSectionVisibleShow}>
                    Add a Section Windows List
               </Button>
           </div>
           
           <DataTable plain baseId="QuizTablePagination">
           <TableHeader>
                 <TableRow selectable={false}>
                 
                 <TableColumn className="quizTableHeaderColumn">Section Name</TableColumn>
                 <TableColumn className="quizTableHeaderColumn">Start time</TableColumn>
                 <TableColumn className="quizTableHeaderColumn">End time</TableColumn>
                 
                 <TableColumn className="quizTableHeaderColumn">Actions</TableColumn>
                          
                 </TableRow>
               </TableHeader>
               <TableBody>
                 {this.state.sectionQuizDetailsArr.map((sectionQuizDetails, i) => (
                   <TableRow selectable={false} key={i}>
                       <TableColumn className="quizTableColumn">
                       {sectionQuizDetails.section_name}
                       </TableColumn>                      
                       <TableColumn className="quizTableColumn">
                       {sectionQuizDetails.section_start_time}
                       </TableColumn>
                       <TableColumn className="quizTableColumn">
                       {sectionQuizDetails.section_end_time}
                       </TableColumn>
                       
                       <TableColumn className="quizTableColumn">
                       
                       <div><Button
                           id={JSON.stringify(sectionQuizDetails)}
                           onClick={() => this.editSectionDetails(i)}
                           className="buttonBorder buttonNotification"
                           flat
                           >
                           Edit
                           </Button>
                        </div>

                           
                   
                       </TableColumn>
                       
                   </TableRow>
                   ))}
                   </TableBody>
                   </DataTable>
         </Card>
            <Card className="cards__example md-cell md-cell--6 md-cell--8-tablet" style={{float:"left"}}>
            <div>
          <DialogContainer
             id="navigation-drawer-demo"
             aria-label="Navigation Drawer Demo"
            visible={this.state.updateVisible}
            fullPage
            focusOnMount={false}           
            onHide={this.updateVisibleHide}
            
            
            
          >
          <div>
            {' '}

            <Button  icon onClick={this.updateVisibleHide}>
              close
            </Button>
           
          </div>

         
          <div style={{width:"700px",marginLeft: "25%"}}>
          <h3>{this.state.studentEditIsEnable === true ? "Student Edit Window" : "Add Student Window"  }</h3>
         <Grid style={{width:'100%'}}>
            <Cell size={12} phoneSize={4} tabletSize={8}>
            <Autocomplete
              id="studentIDSearch"
              label="User ID"
              placeholder="User ID"
              data={this.studentQuizTimeList()}
              onChange={this.handleUserIDSearch}
              onAutocomplete={this.handleAutocomplete}
              value={this.state.studentID}
              disabled={this.state.studentEditIsEnable}
            />
            </Cell><br/>
            <Cell size={6} phoneSize={4} tabletSize={8}>
            <DatePicker
                    id="sstartDate"
                    label="Start Date"
                    displayMode="portrait"
                    value={isValidDate(studentStartDateLocal)?studentStartDateLocal:""}
                    onChange={this.handleStudentStartDate}


            />
            </Cell>
            <Cell size={6} phoneSize={4} tabletSize={8}>
            <TimePicker
                    id="sstartTime"
                    label="Start Time"
                    displayMode="portrait"
                    value={isValidDate(studentStartDateLocal)?studentStartDateLocal:""}
                    onChange={this.handleStudentStartDate}

            />  
            </Cell>
            <Cell size={6} phoneSize={4} tabletSize={8}>
            
            <DatePicker
                    id="endDate"
                    label="End Date"
                    displayMode="portrait"
                    value={isValidDate(studentEndDateLocal)?studentEndDateLocal:""}
                    onChange={this.handleStudentEndDate}
            />
            </Cell>
            <Cell size={6} phoneSize={4} tabletSize={8}>
                <TimePicker
                    id="endTime"
                    label="End Time"
                    displayMode="portrait"
                    value={isValidDate(studentEndDateLocal)?studentEndDateLocal:""}
                    onChange={this.handleStudentEndDate}

                />
            </Cell>
            <Cell size={4} phoneSize={4} tabletSize={8}>
            {this.state.loadingSave === true ? 
                <LoadingSpinner /> : ( 
                <div><Button
                raised
                primary
                style={{marginRight:'10px'}}
                className="buttonColour"
                onClick={this.state.studentEditIsEnable === true ? this.updateStudentDetails : this.saveStudentQuizTime}>
                {this.state.studentEditIsEnable === true ? "Update": "Submit"}</Button> 
               
                &nbsp;&nbsp;&nbsp;
                 <Button flat
                    secondary
                    swapTheming
                     onClick={this.updateVisibleHide}> close</Button>
                     </div>
                )}
            </Cell>
            </Grid>
            </div>

          </DialogContainer>
        </div>                
            

            <div>
                <h2 style={{paddingTop:"5px",paddingLeft:"20px"}}>Students Window List </h2>
                <Button className="archive-button" primary raised
                  onClick={this.updateVisibleShow}
                  style={{
                    marginLeft:"18px"
                  }}>
                    Add
                </Button>
            <DataTable plain baseId="QuizTablePagination">
            <TableHeader>
                  <TableRow selectable={false}>
                  <TableColumn className="quizTableHeaderColumn">User Name</TableColumn>
                  <TableColumn className="quizTableHeaderColumn">Start time</TableColumn>
                  <TableColumn className="quizTableHeaderColumn">End time</TableColumn>
                  
                 
                  <TableColumn className="quizTableHeaderColumn">Updated At</TableColumn>
                  <TableColumn className="quizTableHeaderColumn">Updated By</TableColumn>
                  <TableColumn className="quizTableHeaderColumnActions">Actions</TableColumn>
                           
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {this.state.studentQuizDetailsArr.map((studentQuizDetails, i) => (
                    <TableRow selectable={false} key={i}>
                        <TableColumn className="quizTableColumn">
                        {studentQuizDetails.student_id}
                        </TableColumn>
                        <TableColumn className="quizTableColumn">
                        {moment.tz(studentQuizDetails.student_start_time,"UTC").format("MM/DD/YYYY HH:mm")}
                        </TableColumn>
                        <TableColumn className="quizTableColumn">
                        {moment.tz(studentQuizDetails.student_end_time,"UTC").format("MM/DD/YYYY HH:mm")}
                        </TableColumn>
                        
                        <TableColumn className="quizTableColumn">
                        {studentQuizDetails.updated_at ? moment.tz(studentQuizDetails.updated_at,"UTC").format("MM/DD/YYYY HH:mm") : ""}
                        </TableColumn>
                        <TableColumn className="quizTableColumn">
                        {studentQuizDetails.updated_by}
                        </TableColumn>
                        
                        <TableColumn className="quizTableColumn">
                        
                        <div><Button
                            id={JSON.stringify(studentQuizDetails)}
                            onClick={() => this.editStudentDetails(i)}
                            className="buttonBorder buttonNotification"
                            flat
                            >
                            Edit
                            </Button>
                            &nbsp;
                            <Button
                            id={studentQuizDetails.student_id}
                            className="buttonBorder buttonNotification"
                            flat
                            onClick={() => this.delete(studentQuizDetails)}
                            >
                            Delete
                </Button></div>

                            
                    
                        </TableColumn>
                        
                    </TableRow>
                    ))}
                    </TableBody>
                    </DataTable>
                        
          </div>
          </Card>
          <Card className="cards__example md-cell md-cell--6 md-cell--8-tablet"  style={{float:"left"}}>
          <div> <h2 style={{paddingTop:"5px",paddingLeft:"20px"}}>Release Locks</h2></div>
          <div style={{marginBottom:"10px", paddingLeft:"20px", marginRight:"5px"}}>
            <label className="quizTableHeaderColumn"> Select the students for release lock </label>
          <EnrolledStudentsDropDown  
                studentListArray = {this.state.studentIDObj}
                onChange = {this.onStudentChange.bind(this)}
          />
          </div>
          <div style={{marginBottom:"20px"}}>
          <Button className="archive-button" primary raised
                  disabled={this.state.releaseStudentIDs.length === 0}
                  onClick={this.releaseLocks}
                  style={this.state.releaseStudentIDs.length === 0 ? disabledButton : {
                    marginLeft:"18px"
                  }}>
                    Release
                </Button>
          </div> 
          </Card>
          <Card className="cards__example md-cell md-cell--6 md-cell--8-tablet" style={{float:"left"}}>          
              <div>
                <h2 style={{paddingTop:"5px",paddingLeft:"20px"}}>Release Locks History </h2>
            <DataTable plain baseId="QuizTablePagination">
            <TableHeader>
                  <TableRow selectable={false}>
                  <TableColumn className="quizTableHeaderColumn">S No</TableColumn>
                  <TableColumn className="quizTableHeaderColumn">Student ID</TableColumn>
                  <TableColumn className="quizTableHeaderColumn">Updated At</TableColumn>
                  
                  <TableColumn className="quizTableHeaderColumn">Updated By</TableColumn>
                           
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {this.state.slicedLocksData.map((lockData, i) => (
                    <TableRow selectable={false} key={i}>
                        <TableColumn className="quizTableColumn">
                        {lockData.sno}
                        </TableColumn>
                        <TableColumn className="quizTableColumn">
                        {lockData.student_id}
                        </TableColumn>
                        <TableColumn className="quizTableColumn">
                        {lockData.updated_at ? moment.tz(lockData.updated_at,"UTC").format("MM/DD/YYYY HH:mm") : ""}
                        </TableColumn>
                        
                        <TableColumn className="quizTableColumn">
                        
                        {lockData.updated_by ? lockData.updated_by : ""}

                            
                    
                        </TableColumn>
                        
                    </TableRow>
                    ))}
                    </TableBody>
                    <TablePagination
                     className='custom-pagination'
                      rowsPerPageItems={[3, 8, 12, 16, 20]}
                      defaultRowsPerPage={8}
                      rows={this.state.locksHistory?.length}
                      rowsPerPageLabel=""
                      onPagination={this.handlePagination}
                    />
                    </DataTable>
                        
          </div>
          </Card>
        </div>
        );
    }
}